import React, { useCallback, useState } from 'react';
import { Button, Select } from 'modules/ui';
import { useAppDispatch } from 'store';
import { Text, AccessName } from './styles';
import { FlexContainer } from 'styles/FlexContainer';
import { accessItems, accessSourceEditSelect } from '../constants';
import { ModalComponentType } from 'store/reducers/modals/types';
import { GroupType } from 'types/store';
import { AccessInterface } from 'types/types';
import {
  updateSourceAccessByIdAction,
  updateSourceAccessGroupAction,
  updateSourceAccessUserAction,
} from 'store/reducers/sources/actions';

interface EditAccessModalProps {
  sourceAccess: AccessInterface;
  activeSourceId: string;
}

export const EditAccessModal: ModalComponentType<EditAccessModalProps> = ({ sourceAccess, activeSourceId, onClose }) => {
  const dispatch = useAppDispatch();

  const [type, setType] = useState<GroupType>(sourceAccess.type);

  const sourceAccessId = sourceAccess?.id;

  const onEdit = useCallback(
    async () => {
      try {
        if (activeSourceId) {
          const response =
            sourceAccess.entity === 'group'
              ? await dispatch(
                  updateSourceAccessGroupAction({ sourceId: activeSourceId, type, groupId: sourceAccessId }),
                ).unwrap()
              : await dispatch(updateSourceAccessUserAction({ sourceId: activeSourceId, type, userId: sourceAccessId })).unwrap();

          if (response) {
            dispatch(updateSourceAccessByIdAction({ sourceAccess: { ...sourceAccess, type } }));
          }
        }
      } catch (error) {
        /* TODO: Error output in the future */
        console.error(error);
      } finally {
        onClose();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeSourceId, sourceAccess, type, sourceAccessId, onClose],
  );

  return (
    <FlexContainer width="100%" flexDirection="column" padding="4px" gap="16px" height="100%">
      <FlexContainer flexDirection="column">
        <Text>Группа/пользователь</Text>
        <AccessName>{sourceAccess.name}</AccessName>
      </FlexContainer>

      <FlexContainer flexDirection="column">
        <Text>Права</Text>
        <Select
          needBackground={false}
          width="100%"
          name={accessSourceEditSelect}
          value={type}
          onChange={setType}
          options={accessItems}
        />
      </FlexContainer>

      <FlexContainer gap="10px" marginLeft="auto" marginTop="16px">
        <Button needBackground={false} text="Отмена" iconSize="normal" heightSize="normal" onClick={onClose} />
        <Button text="Изменить" iconSize="normal" heightSize="normal" onClick={onEdit} />
      </FlexContainer>
    </FlexContainer>
  );
};
